import { useEffect, useId, useRef, useState } from 'react';
import PLOT_HELP from './plotHelp.json';

// The "?" after a plot title: a popover with that plot's text from plotHelp.json
// (keyed by the plot id). No text for the id (an unknown column) — no button.
// It sits outside the plot box and keeps its clicks to itself, so opening it
// never moves the cursor or seeks the video.
export default function HelpButton({ id, title }) {
  const label = title ? `Что показывает график: ${title}` : 'Что показывает график';
  const text = PLOT_HELP[id];
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const popoverId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    const onOutside = (e) => { if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('keydown', onKey);
    // Capture phase: the other "?" stops propagation of its pointerdown (to keep
    // click-to-seek off), which in React 17+ also stops it before document's bubble.
    document.addEventListener('pointerdown', onOutside, true);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('pointerdown', onOutside, true);
    };
  }, [open]);

  if (!text) return null;
  const stop = (e) => e.stopPropagation();
  return (
    <span ref={rootRef} className="relative inline-flex" onClick={stop} onPointerDown={stop}>
      <button
        type="button"
        aria-label={label}
        aria-expanded={open}
        aria-controls={open ? popoverId : undefined}
        onClick={() => setOpen((v) => !v)}
        className="inline-flex h-5 w-5 items-center justify-center rounded-full border border-border
                   text-xs font-semibold text-muted-foreground hover:text-primary hover:border-primary"
      >
        ?
      </button>
      {open && (
        <span
          id={popoverId}
          role="note"
          aria-label={label}
          className="absolute left-0 top-full z-30 mt-1 w-72 max-w-[80vw] rounded-lg border border-border
                     bg-background p-3 text-xs font-normal leading-relaxed text-primary shadow-lg"
        >
          {text}
        </span>
      )}
    </span>
  );
}
